import React, { useState } from 'react';

import { Modal, Header, Body, Footer, FooterButton } from './modalElements';
import { ModalContent, ModalTextArea } from './styles';

// A generic modal that can take text input and submit or cancel
export default React.memo(({ title, text, onSubmit, onCancel, isOpen = true, loading = false, placeholder = '' }) => {
  const [textInput, setTextInput] = useState('');

  return (
    <Modal isOpen={isOpen}>
      {title && <Header>{title}</Header>}
      <Body loading={loading}>
        {text && <ModalContent>{text}</ModalContent>}
        <ModalTextArea
          autoFocus
          value={textInput}
          onChange={(event) => setTextInput(event.target.value)}
          placeholder={placeholder}
        />
      </Body>
      <Footer>
        {onCancel && <FooterButton label="Cancel" onClick={onCancel} />}
        <FooterButton label="Submit" onClick={() => onSubmit(textInput)} disabled={loading} />
      </Footer>
    </Modal>
  );
});
